import { render, staticRenderFns } from "./TapestryScoresPlay.vue?vue&type=template&id=761f5fc7"
import script from "./TapestryScoresPlay.vue?vue&type=script&lang=ts"
export * from "./TapestryScoresPlay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports